import { RefObject, useEffect } from 'react';

export const DROPDOWN_PANEL_SELECTOR = '[data-dropdown-panel]';

type UseClickOutsideOptions = {
  isActive: boolean;
  containerRef: RefObject<HTMLElement | null>;
  onOutside: () => void;
  event?: 'click' | 'mousedown';
};

export const useClickOutside = ({
  isActive,
  containerRef,
  onOutside,
  event = 'mousedown',
}: UseClickOutsideOptions) => {
  useEffect(() => {
    if (!isActive) return;

    const onPointer = (pointerEvent: MouseEvent) => {
      const target = pointerEvent.target as Node;

      if (containerRef.current?.contains(target)) return;
      if (target instanceof Element && target.closest(DROPDOWN_PANEL_SELECTOR)) return;

      onOutside();
    };

    document.addEventListener(event, onPointer);
    return () => document.removeEventListener(event, onPointer);
  }, [containerRef, event, isActive, onOutside]);
};
